import { defineStore } from "pinia";
import { StatsDto } from "@/models/dto/statsDto";
import { FlagsDto } from "@/models/dto/flagsDto";
import { RiskCategory } from "@/models/enum/riskCategory";
import { getStatsSummary } from "@/services/statsService";

export interface IStatsState {
  stats: StatsDto;
  flagging: FlagsDto;
  selectedRiskCategory: RiskCategory;
}

export const useStatsStore = defineStore("statsStore", {
  state: (): IStatsState => ({
    stats: new StatsDto(),
    flagging: new FlagsDto(),
    selectedRiskCategory: RiskCategory.LabourAndHumanRight,
  }),

  getters: {
    // Entire chain answer status
    completedPercentage(state) {
      return state.stats.supplyChainAnswerStats.completedPercentage;
    },
    completedUnits(state) {
      return state.stats.supplyChainAnswerStats.completed;
    },
    totalNumberOfUnits(): number {
      return (
        this.stats.supplyChainAnswerStats.total
      );
    },

    // Tier 1 answer status
    completedPercentageTier1(state) {
      return state.stats.tier1AnswerStats.completedPercentage;
    },
    completedUnitsTier1(state) {
      return state.stats.tier1AnswerStats.completed;
    },
    totalNumberOfUnitsTier1(): number {
      return this.stats.tier1AnswerStats.total;
    },

    // Business partner answer status
    completedPercentageBusinessPartners(state) {
      return state.stats.businessPartnerAnswerStats.completedPercentage;
    },
    completedUnitsBusinessPartners(state) {
      return state.stats.businessPartnerAnswerStats.completed;
    },
    totalNumberOfUnitsBusinessPartners(): number {
      return this.stats.businessPartnerAnswerStats.total;
    },
  },

  actions: {
    async setStatsSummary(questionnaireId: string): Promise<void> {
      let summary = await getStatsSummary(questionnaireId);
      this.stats = summary.answerStatsSummary;
      this.flagging = summary.flags;
    },
  },
});
